import { gql } from '@apollo/client';

export const ADD_BLOG_ARTICLE = gql`
  mutation ($input: AddBlogArticleInput!, $file: Upload!) {
    addBlogArticle(input: $input, file: $file) {
      _id
      photoName
      title
      description
      content
      createdAt
      photoUrl
    }
  }
`;
